import { render, staticRenderFns } from "./AupairSponsorsList.vue?vue&type=template&id=35bc6127&"
import script from "./AupairSponsorsList.vue?vue&type=script&lang=js&"
export * from "./AupairSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports